import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AumicoCoreModule } from '@modeso/aumico-lib-core-fe';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18NextModule } from 'angular-i18next';
import { AumicoComponentsModule } from '../../../../../aumico-components/src/lib';
import { AnalyticsEffects } from '../../effects/analytics.effects';
import { ANALYTICS_FEATURE_KEY, analyticsReducer } from '../../reducer/analytics.reducer';
import { CurrencyMismatchBannerComponent } from './banners/currency-mismatch-banner/currency-mismatch-banner.component';
import { DeltaModeToggleComponent } from './controls-bar/delta-mode-toggle/delta-mode-toggle.component';
import { ComparisonControlsBarComponent } from './controls-bar/comparison-controls-bar.component';
import { LanguageSwitchComponent } from './controls-bar/language-switch/language-switch.component';
import { ReportScopeToggleComponent } from './controls-bar/report-scope-toggle/report-scope-toggle.component';
import { RatioToggleComponent } from './controls-bar/ratio-toggle/ratio-toggle.component';
import { YearPillsComponent } from './controls-bar/year-pills/year-pills.component';
import { MultiYearExportModalComponent } from './export-modal/multi-year-export-modal.component';
import { MultiYearLanguageSelectionModalComponent } from './language-selection-modal/multi-year-language-selection-modal.component';
import { HarmonizedComparisonTableComponent } from './harmonized-comparison-table/harmonized-comparison-table.component';
import { MultiYearComparisonContainerComponent } from './multi-year-comparison-container/multi-year-comparison-container.component';
import { EmptyStateViewComponent } from './states/empty-state-view/empty-state-view.component';
import { NormalStateViewComponent } from './states/normal-state-view/normal-state-view.component';

const COMPONENTS = [
    MultiYearComparisonContainerComponent,
    EmptyStateViewComponent,
    NormalStateViewComponent,
    ComparisonControlsBarComponent,
    YearPillsComponent,
    DeltaModeToggleComponent,
    ReportScopeToggleComponent,
    RatioToggleComponent,
    HarmonizedComparisonTableComponent,
    CurrencyMismatchBannerComponent,
    MultiYearExportModalComponent,
    MultiYearLanguageSelectionModalComponent,
    LanguageSwitchComponent,
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        I18NextModule,
        MatDialogModule,
        AumicoCoreModule,
        AumicoComponentsModule,
        StoreModule.forFeature(ANALYTICS_FEATURE_KEY, analyticsReducer),
        EffectsModule.forFeature([AnalyticsEffects]),
    ],
    exports: [MultiYearComparisonContainerComponent],
})
export class MultiYearComparisonModule {}
